const ACTION = {
    FETCH_START: 'FETCH_START',
    FETCH_END: 'FETCH_END',
    REMOVE_ERROR: 'REMOVE_ERROR',
    DISPLAY_ERROR: 'DISPLAY_ERROR',
    UPDATE_REASON_KEY: 'UPDATE_REASON_KEY',
};

const INIT_STATE = {
    isFetching: false,
    hasError: false,
    errorMessage: null,
    selectedReasonKey: null,
};

const reducer = (state, action) => {
    const { type, payload } = action;

    switch (type) {
        case ACTION.FETCH_START: {
            return {
                ...state,
                isFetching: true,
            };
        }
        case ACTION.FETCH_END: {
            return {
                ...state,
                isFetching: false,
            };
        }
        case ACTION.DISPLAY_ERROR: {
            const { errorMessage } = payload;

            return {
                ...state,
                errorMessage,
                hasError: true,
                isFetching: false,
            };
        }
        case ACTION.REMOVE_ERROR: {
            return {
                ...state,
                errorMessage: null,
                hasError: false,
            };
        }
        case ACTION.UPDATE_REASON_KEY: {
            const { selectedReasonKey } = payload;

            return {
                ...state,
                errorMessage: null,
                hasError: false,
                selectedReasonKey,
            };
        }
        default: {
            return state;
        }
    }
};

export {
    ACTION,
    INIT_STATE,
};

export default reducer;
